import Header from '../../../components/Header'
import RecipeByIngredients from '../../../components/RecipeByIngredients'

const MealIngredients = () => (
  <>
    <Header />
    <div className="container">
      <RecipeByIngredients></RecipeByIngredients>
    </div>
  </>
)

export default MealIngredients
